// ============================================================================
// src/BriefCall.js   —  mini “AI Summary Call” widget (English)
// ============================================================================
import React, { useState } from "react";
import { FaPhoneAlt }     from "react-icons/fa";
import './BriefCall.css'; 
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const API = process.env.REACT_APP_API_URL || "http://localhost:5001";

export default function BriefCall({ items }) {
  const [phone,   setPhone]   = useState("");
  const [loading, setLoading] = useState(false);
  const [status,  setStatus]  = useState(null);

  /* ---- Call backend ---- */
  async function handleCall() {
    if (!phone) {
      alert("Please enter a phone number");
      return;
    }
    setLoading(true);
    setStatus(null);

    try {
      const res  = await fetch(`${API}/api/call-summary`, {
        method : "POST",
        headers: { "Content-Type": "application/json" },
        body   : JSON.stringify({ to: phone, items }),
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);

      setStatus({ type: "success", msg: "📞 Lex Mail is calling you from 888-884-5281. Please pick up." });
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", msg: "Call failed. Please try again later." });
    } finally {
      setLoading(false);
    }
  }

  /* ---- UI ---- */
  return (
    <div className="brief-call-container">
      <div className="brief-call-box">
        <FaPhoneAlt className="brief-call-icon" />
        <div className="brief-call-text">
          <h4>AI Summary Call</h4>
          <p>Enter a phone number and let AI read today’s email summary to you.</p>
        </div>
      </div>

     <PhoneInput
  country={'us'}
  value={phone}
  onChange={phone => setPhone(`+${phone}`)}
  inputClass="brief-call-input"
  containerStyle={{ flex: 1 }}
  inputStyle={{
    width: '100%',
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid #ddd',
    color: '#fff',
    fontSize: '15px',
    borderRadius: 0
  }}
  buttonStyle={{
    background: 'transparent',
    border: 'none'
  }}
/>


      <button
        className="brief-call-button"
        onClick={handleCall}
        disabled={loading}
      >
        {loading ? "Calling…" : `Call ${phone || ""}`}
      </button>

      {status && (
        <p
          className={
            status.type === "success"
              ? "brief-call-success"
              : "brief-call-error"
          }
        >
          {status.msg}
        </p>
      )}
    </div>
  );
}
